var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-row',{staticStyle:{"display":"flex","flex-wrap":"wrap","margin-right":"-9px","margin-left":"-12px"}},[_c('b-col',{attrs:{"lg":"12","sm":"12"}},[_c('form-input',{key:_vm.reloadComponent,attrs:{"load":_vm.load,"data":_vm.formInputData},on:{"change":_vm.setData,"submit":_vm.register}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }